import moment from 'moment-timezone';

export class PostedCommissionTrueUp {
	public commissionId: string;
	public contractId: string;
	public agentId: string;
	public contractLocationId: string;
	public purchasingLayerHistoryId: number;
	public contractNum: string;
	public agentName: string;
	public commissionDate: Date;
	public trueUpUsage: number;
	public trueUpAmount: number;
	public margin: number;
	public rate: number;
	public effectiveDate: Date;
	public expirationDate: Date;
	public description: string;
	public addDate: Date;
	public paidDate: Date;
	public postedByName: string;
	public isActive: boolean;
	public isFraudulent: boolean;

	constructor(data?: Partial<PostedCommissionTrueUp>) {
		Object.assign(this, data);

		this.commissionDate = this.toLocalDateOnly(this.commissionDate);
		this.effectiveDate = this.toLocalDateOnly(this.effectiveDate);
		this.expirationDate = this.toLocalDateOnly(this.expirationDate);
		this.addDate = this.toLocalDateOnly(this.addDate);
		this.paidDate = this.toLocalDateOnly(this.paidDate);
	}

	private toLocalDateOnly(value: Date | string): Date {
		if (!value) {
			return value as Date;
		}
		return new Date(moment.utc(value).format('MMM DD, YYYY 00:00:00 a'));
	}
}
